/// <amd-module name="Artifacts/Root/types/IDependency" />
export interface IDependencyGroup {
  group: string;
  dependencies: IDependency[];
}

export interface IDependency {
  name: string;
  versionRange: string;
  link: string;
  packageId: string;
  packageVersionId: string;
  normalizedPackageName: string;
  protocolType: string;
}
